import { DEPOSIT_PROVIDER_CODE } from './enums';

export enum FIAT_CODE {
  BRL = 'BRL',
  EUR = 'EUR',
  USD = 'USD',
}
export enum WALLET_CODE {
  EUR = 'EUR',
  BRL = 'BRL',
  BTC = 'BTC',
  ETH = 'ETH',
  XRP = 'XRP',
  USDT = 'USDT',
  LTC = 'LTC',
  BNB = 'BNB',
  DOGE = 'DOGE',
  TRX = 'TRX',
}
export enum CURRENCY {
  EUR,
  BRL,
  USD,
  μBTC,
  BTC,
  ETH,
  XRP,
  LTC,
  BNB,
  DOGE,
  TRX,
  USDT,
}
export interface IWallet {
  type: WALLET_TYPE;
  code: WALLET_CODE;
  currency: CURRENCY;
  image: string;
  name: string;
  metric: number;
  decimals: number;
  ranges: {
    minWithdraw: number;
    minDeposit: number;
  };
  enabled: boolean;
  blockchain?: BLOCKCHAIN;
  blockchains?: ITokenBlockchain[];
  sender?: IWalletSenderAddress;
  risk: number;
}

export const WALLETS_TOKENS = [WALLET_CODE.ETH, WALLET_CODE.TRX, WALLET_CODE.BNB];
export enum TOKEN_CODE {
  NONE = 'NONE',
  USDT = 'USDT',
}
export enum WALLET_TYPE {
  FIAT = 'fiat',
  TOKEN = 'token',
  CRYPTO = 'crypto',
}

export interface IAddress {
  id: string;
  user_id: string;
  expireAt: number;
  walletId: string;
  blockchain: BLOCKCHAIN;
  type: ADDRESS_SUBSCRIPTION_TYPE;
}
export interface IAddressSubscription {
  _id: string;
  referenceId: string;
  address: string;
  type: ADDRESS_SUBSCRIPTION_TYPE;
}
export enum ADDRESS_SUBSCRIPTION_TYPE {
  COINS = 'coins',
  TOKENS = 'tokens',
}
export enum TOKEN_TYPES {
  TRC_20 = 'TRC-20',
  BEP_20 = 'BEP-20',
  ERC_20 = 'ERC-20',
}

export enum BLOCKCHAIN {
  ETHEREUM = 'ethereum',
  BITCOIN = 'bitcoin',
  XRP = 'xrp',
  LITECOIN = 'litecoin',
  BITCOIN_CASH = 'bitcoin-cash',
  BINANCE_SMART_CHAIN = 'binance-smart-chain',
  DOGECOIN = 'dogecoin',
  DASH = 'dash',
  TRON = 'tron',
  ZCASH = 'zcash',
  ETHEREUM_CLASSIC = 'ethereum-classic',
}
export enum CRYPTO_PROVIDERS {
  CRYPTOAPIS = 'cryptoapis',
}
export enum ADDRESS_STATE {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
}
export interface ITokenBlockchain {
  blockchain: BLOCKCHAIN;
  blockchain_base: BLOCKCHAIN;
  code: WALLET_CODE;
  type: TOKEN_TYPES;
  identifier: string;
  image?: string;
  metadata?: {
    loading: boolean;
    title: string;
    desc: string;
    imageUrl: string;
  };
  sender?: IWalletSenderAddress;
}

export interface IWalletSenderAddress {
  address: string;
  balance: number;
}
export enum NETWORK {
  NILE = 'nile',
  MORDOR = 'mordor',
  GORELI = 'goerli',
  TESTNET = 'testnet',
  MAINNET = 'mainnet',
}
export interface IMineInBlock {
  height: number;
  hash: string;
  timestamp: number;
}
export interface IUserWalletBalance {
  user_id: string;
  wallet: WALLET_CODE;
  balance?: number;
  metric?: number;
  deviceId: string;
}
export enum BLOCKCHAIN_EVENTS {
  TOKENS_TRANSACTION_CONFIRMED = 'ADDRESS_TOKENS_TRANSACTION_CONFIRMED',
  COINS_TRANSACTION_CONFIRMED = 'ADDRESS_COINS_TRANSACTION_CONFIRMED',
}
export enum TRANSACTION_EVENTS {
  TRANSACTION_REQUEST_BROADCASTED = 'TRANSACTION_REQUEST_BROADCASTED',
  TRANSACTION_REQUEST_APPROVAL = 'TRANSACTION_REQUEST_APPROVAL',
  TRANSACTION_REQUEST_MINED = 'TRANSACTION_REQUEST_MINED',
}
export interface ICryptoapisEventResponseData {
  product: 'BLOCKCHAIN_EVENTS';
  event: BLOCKCHAIN_EVENTS;
  item: ICryptoConfirmedTransaction | ITokenConfirmedTransaction;
}
export enum ADDRESS_TRANSACTION_DIRECTION {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
}
export interface IConfirmedTransaction {
  blockchain: BLOCKCHAIN;
  network: NETWORK;
  address: string;
  minedInBlock: any;
  transactionId: string;
  direction: ADDRESS_TRANSACTION_DIRECTION;
}
export interface ICryptoConfirmedTransaction extends IConfirmedTransaction {
  amount: string;
  unit: WALLET_CODE;
}
export interface ITokenConfirmedTransaction extends IConfirmedTransaction {
  tokenType: TOKEN_TYPES;
  token: {
    name: string;
    symbol: WALLET_CODE;
    decimals: string;
    amount: string;
    contractAddress: string;
  };
}
export interface IAddressSubscription {
  address: string;
  callbackSecretKey: string;
  callbackUrl?: string;
  callbackURL?: string;
  createdTimestamp: number;
  eventType: BLOCKCHAIN_EVENTS;
  isActive: boolean;
  receiveCallbackOn: number;
  referenceId: string;
  expiredAt?: number; // this param is not returned by cryptoapis
}
export interface IAddressSubscriptionResponse {
  address: IAddress;
  subscription: IAddressSubscription;
}
export interface ICryptoapisResponse {
  apiVersion: string;
  referenceId: string;
  idempotencyKey: string;
  data: any;
}
export interface ICryptoapisEventResponse extends ICryptoapisResponse {
  data: ICryptoapisEventResponseData;
}
export interface ICryptoapisGenerateAddressResponse extends ICryptoapisResponse {
  data: {
    item: {
      address: string;
      createdTimestamp: number;
      label: string;
    };
  };
}
export interface IWithdrawCanRequest {
  can: boolean;
  bonus: boolean;
  code: DEPOSIT_PROVIDER_CODE;
  can_by_betting: boolean;
  can_by_bonus: boolean;
  can_by_code: boolean;
  isFidelidade: boolean;
  promoBonusAmount: number;
  winned_amount: number;
  betted_amount: number;
  userData: {
    cpf: string;
    email: string;
    name: string;
    phone: string;
    surname: string;
  };
}
export interface IWithdrawCanRequestResponse {
  can: boolean;
  compliance_factor: number;
}
